import {
  QUOTE_MAX_CHARS, type QuoteFrameSource, type QuoteSlide, type QuoteSlideStyle,
} from './types';

/**
 * Builds a fresh `QuoteSlide` from a suggested/edited quote span. `'frame'`
 * style slides start with an uncaptured, automatic background (`url: null`,
 * `time: null` — the frame grab happens later) from the carousel's
 * `frameSource`; `'card'` style slides have no background at all.
 */
export function buildSlideFromQuote(
  quote: { text: string; start: number; end: number },
  style: QuoteSlideStyle,
  makeId: () => string,
  frameSource: QuoteFrameSource = 'original',
): QuoteSlide {
  return {
    id: makeId(),
    text: quote.text.trim().slice(0, QUOTE_MAX_CHARS),
    start: quote.start,
    end: quote.end,
    background: style === 'frame'
      ? {
        kind: 'frame', url: null, source: frameSource, time: null,
      }
      : null,
  };
}
